import React, { useState, useEffect, useCallback } from 'react';
import { KeyboardArrowUp } from '@mui/icons-material';

interface FloatingButtonProps {
  targetSelector: string; // Sélecteur CSS pour la div du nom du produit
}

const FloatingButton: React.FC<FloatingButtonProps> = ({ targetSelector }) => {
  const [isVisible, setIsVisible] = useState(false);

  const checkScrollPosition = useCallback(() => {
    const targetElement = document.querySelector(targetSelector);
    
    if (!targetElement) {
      setIsVisible(false);
      return;
    }

    // Obtenir la position de la div du nom du produit par rapport à la fenêtre
    const targetRect = targetElement.getBoundingClientRect();
    
    // Si la div du nom du produit n'est plus visible (dépassée), afficher le bouton flottant
    // targetRect.bottom < 0 signifie que la div est complètement au-dessus de la fenêtre visible
    const hasScrolledPastTarget = targetRect.bottom < 0;
    
    setIsVisible(hasScrolledPastTarget);
  }, [targetSelector]);

  useEffect(() => {
    // Vérifier la position initiale
    checkScrollPosition();

    // Ajouter l'écouteur d'événement de scroll
    window.addEventListener('scroll', checkScrollPosition);

    return () => {
      window.removeEventListener('scroll', checkScrollPosition);
    };
  }, [checkScrollPosition]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  if (!isVisible) return null;

  return (
    <button
      onClick={scrollToTop}
      className="fixed bottom-6 right-6 z-50 bg-black hover:bg-gray-800 text-white rounded-full p-3 shadow-lg transition-all duration-300 ease-in-out hover:scale-110 hover:shadow-xl"
      aria-label="Remonter en haut"
      title="Remonter en haut"
    >
      <KeyboardArrowUp className="w-6 h-6" />
    </button>
  );
};

export default FloatingButton;
